export const geometricTealFrame = () => ({
  id: 'geometric-teal-frame',
  name: 'Geometric Teal Frame',
  thumbnail: '/assets/diploma-templates/09_frame.webp',
  data: {
    elements: [],
    backgroundColor: '#ffffff',
    backgroundImage: {
      url: '/assets/diploma-templates/backgrounds/09_background.svg',
      key: null
    }
  }
});
